import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'antd';
import { useAuth } from '../../../context/AuthContext';
import { employeeService } from '../../../services/employee/employee.service';
import { useApiErrorHandler } from '../../../hooks/useApiErrorHandler';
import EmployeeForm from '../components/EmployeeForm';

const CreateEmployee: React.FC = () => {
    const navigate = useNavigate();
    const { token, selectedBranch } = useAuth();
    const [loading, setLoading] = useState(false);
    const [formErrors, setFormErrors] = useState<Record<string, string[]>>({});
    const { handleError } = useApiErrorHandler();

    const handleSubmit = async (values: any) => {
        if (!token || !selectedBranch) return;

        setLoading(true);
        setFormErrors({});
        try {
            await employeeService.createEmployee(values, token, selectedBranch.id);
            navigate('/employees');
        } catch (error) {
            handleError(error, setFormErrors);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card title="Create Employee">
            <EmployeeForm
                onSubmit={handleSubmit}
                onCancel={() => navigate('/employees')}
                loading={loading}
                serverErrors={formErrors}
            />
        </Card>
    );
};

export default CreateEmployee;
